import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavItem, Container,Dropdown, FormGroup, Button} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ImageElement } from "../../../components";
import { Input } from 'antd';

function TechniHeader() {
    const [scroll, setScroll] = useState(0);
    useEffect(() =>{
        setTimeout(() => {
            let navbar = document.querySelector(".technHead").clientHeight;
            document.querySelector("body").style.paddingTop = `${navbar}px`;
          }, 300);
    });
    useEffect(() => {
        document.addEventListener("scroll", () => {
          const scrollCheck = window.scrollY > 50
          if (scrollCheck !== scroll) {
            setScroll(scrollCheck)
          }
        })
      });
  return (
    <header className={`header technHead position-fixed w-100 ${scroll ? 'scroll' : ''}` }>
        <Container>
            <Navbar expand="lg" className="p-0">         
                <Navbar.Brand href="/home" className="p-0 me-0">
                    <ImageElement source="logo.svg" alt="logo" />
                </Navbar.Brand>            
                <Navbar.Collapse id="navbarScroll">
                <Nav as="ul" className="ms-auto">
                    <NavItem as="li">
                        <Link to="/technician" className="p-0 nav-link">Technicians Join Us</Link>
                    </NavItem>
                    <NavItem as="li">
                        <Link to="/existing-company" className="p-0 nav-link">Company Partner Program</Link>
                    </NavItem>
                        <NavItem as="li">
                    <Link to="/" className="p-0 nav-link">Members Area</Link>
                    </NavItem>
                    <NavItem as="li">
                        <Link to="/technician-faqs" className="p-0 nav-link">FAQ</Link>
                    </NavItem>
                </Nav>
                </Navbar.Collapse>
                {/* <div className="d-flex searchBox align-items-center">
                    <Link as="button"><em className="gg-search"/></Link>                     
                </div>  */}
                <div className="d-flex searchBox align-items-center afterloginHeader_right">
                    <Dropdown align="end">
                        <Dropdown.Toggle  as="a" className="rounded-circle position-relative" id="searchBox">
                        <em className="gg-search" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="border-0 searchBox_card">
                                <FormGroup className="form-group position-relative searchBox_card_inner mb-0">
                                    <Input type="text" size="large" placeholder="Search"  />
                                    <Button className="btn position-absolute bg-transparent border-0 text-500 searchBtn"><em className="gg-search"/></Button>
                                </FormGroup>
                        </Dropdown.Menu>
                    </Dropdown>
                </div> 
                <Navbar.Toggle as="a" className="border-0 p-0" aria-controls="navbarScroll">
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>                 
            </Navbar>
        </Container>
    </header>
  );
  
}
  
export default TechniHeader;